<template>
<div id="lower-body" :class="this.currentResource">
  <div id="resources" class="content">

    <div class="pure-g">
        <div class="pure-u-1 pure-u-lg-1-2">
          
          <section class="feature">
            <div class="sectionIcon"><div class="icon-bg"><label class="icon-reminder"></label></div></div>
            <div class="sectionText">
              <h1>Running reminders</h1>
              <p>By pledging to run you’ll receive occasional emails encouraging you to go out for a jog.
<div class="small">This is a free service and you can unsubscribe at any time with a single click.</div></p>
            </div>
          </section>

        </div>
        <div class="pure-u-1 pure-u-lg-1-2">
          
          <section class="feature">
            <div class="sectionIcon"><div class="icon-bg"><label class="icon-donate"></label></div></div>
            <div class="sectionText">
              <h1>Support Running Year</h1>
              <p>Donate any amount to help us get more people fit, healthy and running in {{this.sharedState.year}}</p>
              <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="MMFWNSKDZVWUA">
<input type="submit" border="0" name="submit" value="Donate with PayPal" id="donateButton">
<img alt="" border="0" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1">
</form>
            </div>
          </section>

        </div>
    </div>

    <!-- View all resource categories -->
    <section class="feature">
      <div class="sectionIcon"><div class="icon-bg"><label class="icon-resources"></label></div></div>
      <div class="sectionText">
        <h1>Running resources<span v-if="this.currentResource"> &rsaquo; {{ this.getResourceData('name') }}</span></h1>
        <p>We've curated a list of {{ this.getResourceCount() }} resources for runners, to get you on the right track and help you run better.<br/><span v-if="this.sharedState.pledgeCompleted">Click on one of the categories below to get started..</span><span v-else>To access them, you need to pledge to run first.</span></p>
      </div>
    </section>

      <transition-group tag="ul" name="slide" id="resourceMosaic">
        
        <!-- Go Back -->
        <li key="back" @click="setCurrentResource(false)" v-if="this.currentResource">
          <div class="resource">
            <div class="card goBackCard">
              <h2>View the whole collection of running resources</h2>
            </div>
            <div class="button">&lsaquo; Go Back</div>
          </div>
        </li>
        <!-- /Go Back -->

        <template v-for="(category, key) in resources">

          <!-- Parent tile -->
          <li :key="category.name" @click="setCurrentResource(key)" v-if="noResourceSelected()">
            <resource-collection :cardClass="key" :totalItems="category.resources.length" :isUnlocked="isPledgeCompleted">
              <h1 slot="title">{{category.name}}</h1>
              <p slot="description">{{category.description}}</p>
            </resource-collection>
          </li>          
          <!-- /Parent tile -->

          <!-- Resource tile -->
          <li v-for="resource in category.resources" :key="resource.name" v-if="isCurrentResource(key)">
            <a :href="resource.website" :title="resource.name" class="resourceLink" target="new">
              <resource :website="resource.website" :logo="resource.logo">
                <h1 slot="title">{{resource.name}}</h1>
                <p slot="description">{{resource.description}}</p>
              </resource>
            </a>
          </li>
          <!-- /Resource tile -->

        </template>

        <!--
        <li v-for="(category, key) in resources" :key="category.name" v-if="isCurrentResource(key)" @click="goToResource(key)">
          {{key}} is OPEN
        </li>
        -->

      </transition-group>
    
  </div>


<modal v-if="this.sharedState.showModal" @close="showModal = false"></modal>

</div><!--/lower-body-->
</template>


<script>
/*
<a class="twitter-timeline" data-dnt="true" href="https://twitter.com/TwitterDev">Tweets by TwitterDev</a>
<!-- <**SCRPT** async src="//platform.twitter.com/widgets.js" charset="utf-8"></**SCRPT**> -->
*/

// Add the Resource Collection JS file
import './resourceCollection'

var Vue = require('vue')


Vue.component('resource-collection', {
  props: {
    cardClass: {
      type: String,
      required: true
    },

    totalItems: {
      type: Number,
      required: false
    },

    isUnlocked: {
      type: Boolean,
      required: true
    }
  },

  filters: {
    doubleDigit : function (digit){
      return (digit <= 9 ? '0'+digit : digit);
    }
  },

  // Make new component
  template: '<div><div class="resource resourceCollection"><div :class="cardClass" class="card"><slot name="title">DEFAULT-TITLE</slot><slot name="description">DEFAULT-DESC</slot><span>{{ totalItems | doubleDigit }}</span></div><div class="button"><label v-if="isUnlocked">View resources &rsaquo;</label><label v-else>Pledge to view</label></div></div><div class="total">{{ totalItems }} resources</div></div>'
});

Vue.component('resource', {
  props: {
    website: {
      type: String,
      required: false
    },
    logo : {
      type: String,
      required: false
    }
  },

  filters: {
    logoPath: function (filename) {

      // Check if we have a URL already
      if (filename.indexOf("://") > -1) {
        return filename;
      }

      return "./static/resources/"+filename;
    },
    clearURL: function (url) {

      if (!url) return '';

      var domain;
      //find & remove protocol (http, ftp, etc.) and get domain
      if (url.indexOf("://") > -1) {
          domain = url.split('/')[2];
      }else {
          domain = url.split('/')[0];
      }

      //find & remove www
      if (domain.indexOf("www.") > -1){
        domain = domain.split('www.')[1];
      }

      // Capitalise
      domain = domain.charAt(0).toUpperCase() + domain.slice(1);

      if(domain == "Amzn.to"){
        return "Amazon.com";
      }

      if(domain.length >= 20){
        return domain.substring(0, 20)+'...';
      }

      return domain;
    }
  },

  // Make new component
  template: '<div class="resource"><div class="card"><slot name="title">DEFAULT-TITLE</slot><slot name="description">DEFAULT-DESC</slot><img :src="logo | logoPath" class="resourceLogo" /></div><div class="button">Go to {{ website | clearURL}} &rsaquo;</div></div>'
});





export default {
  name: 'resources',
  data () {
    return {
      sharedState : this.$store.state,
      currentResource: false,
      resources : resourceCollection,
      showModal : false
    }
  },
  components : {
    'modal': require('./Modal.vue'),
  },

  computed: {
    // Allow local access to shared state property
    isPledgeCompleted () {
      return this.sharedState.pledgeCompleted
    }
  },

  methods: {

    noResourceSelected: function(){
      return this.currentResource === false;
    },

    setCurrentResource: function(resourceName){
      //console.log("Called setCurrentResource: "+resourceName)

      if(this.isPledgeCompleted){
        this.currentResource = resourceName;
      }else{
        // Pledge not complete

        this.sharedState.showModal = true;

        var btn = document.getElementById('pledgeButtons');
        btn.classList ? btn.classList.add('pulsate') : btn.className += ' pulsate';
        window.location.hash = '#pledge-form';
        history.pushState("", document.title, window.location.pathname);
        //window.scrollTo(0,0)
      }
    },

    isCurrentResource: function(resourceName){
      //console.log("Checking isCurrentResource: "+resourceName)
      return this.currentResource === resourceName;
    },

    getResourceData: function(field){
      var resource = this.currentResource;

      if(field == "description"){
        var desc = resourceCollection[resource][field];
        var totalResources = resourceCollection[resource].resources.length;
        return desc + " • "+totalResources+" resources";        
      }

      return resourceCollection[resource][field];
      //return "A curated list of 17 resources of help you craft better invoices"
    },

    getResourceCount: function(){
      var totalResources = 0;

      for(var resIndex in resourceCollection){
        totalResources+= resourceCollection[resIndex].resources.length
      }

      // Update store
      this.sharedState.totalResources = totalResources;

      return totalResources
    }
  }
  /*,
  components: {
    App
  }*/
}
</script>

<style>

/*
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
*/

#lower-body{
  /*background-color: #F2F2F2;*/
  padding-top: 20px;
  background-size: cover !important;
  margin-top: 80px;
  background: linear-gradient(rgba(0,0,0,.75),rgba(0,0,0,.75));
}

#resourceMosaic{
  margin: -20px 0 0 0;/*30px -5px 0 -5px;*/
}

/* NEW LI */

#resourceMosaic li{
  display: inline-block;
  width: 33.3333%;
  margin: 0;
}

@media only screen and (max-width: 64em) {
/* Medium screen styles */
  #resourceMosaic li{
    width: 50%;
  }
}

@media only screen and (max-width: 48em) {
      /* Small screen styles */
  #resourceMosaic li{
    width: 100%;
  }

  #resources.content{
    /*margin:0 20px;*/
  }

  #resourceMosaic{
    margin: 30px 15px 0px 15px;
  }

  #resources .resource{
    margin: 50px 0 !important;
  }

  #resources .resourceCollection{
    margin: 0 !important;
  }

}

/* END OF NEW LI */

#resources{
  color: #FFF;
}

section.feature{
  margin: 10px 20px 50px;
  min-height: 130px;
}

.sectionIcon{
  height: 130px;
  width: 150px;
  position: absolute;
}

.sectionIcon .icon-bg{
  border: 5px solid rgba(51, 51, 51, 0.75);
  background-color: rgba(17,17,17,.65);
}

.sectionIcon label,
.sectionIcon .icon-bg{
  height: 120px;
  width: 120px;
  
  border-radius: 100px;
  margin: 0;
  padding: 0;
}

.sectionIcon label{
  display: block;
  background: url(../assets/ry-icons.png);
  background-repeat: no-repeat;  
}


label.icon-reminder{
  background-position: -3px center;
}

label.icon-donate{
  background-position: -466px center;
}

label.icon-resources{
  background-position: -246px center;
}

.sectionText{
  margin: 15px;
  margin-left: 160px;
}

.sectionText h1{
  margin: 0;
  font-weight: 100;
  font-size: 30px;
  font-family: "Avenir", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.sectionText .small{
  color: rgba(153, 153, 153, 0.75);
  font-size: 15px;
  line-height: 24px;
  margin-top: 5px;
}

.sectionText p{
    font-weight: 200;
  color: #ccc;
  margin: 10px 0 0 0;
  font-size: 17px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  letter-spacing: 1px;
  line-height: 28px;
}

@media only screen and (max-width: 48em) {
  /* Small screen styles */

  .sectionIcon{
    position: relative;
    left: calc(50% - 60px);
  }

  .sectionText{
    margin:0;
  }

}

#donateButton{
  border: 0;
  margin-top: 10px;
  padding: 6px;
  color: #FFF;
  background: rgb(86, 180, 111);
  border-bottom: 3px solid rgb(77, 129, 87);
  display: block;
  width: 100%;
  font-weight: 300;
  font-family: "Helvetica Neue";
  line-height: 26px;
  letter-spacing: 1px;
  font-size: 17px;
}

#donateButton:hover{
  /*background-color: rgb(77, 129, 87);*/
  background: rgb(255, 255, 255);
  color:#333;
}

#donateButton:active{
  color: #FFF;
  background: rgb(86, 180, 111);
  border-bottom: 3px solid rgb(77, 129, 87);
  outline: none;
  outline-style:none;
}

#resources h1{
  margin: 0;
  font-weight: 100;
}

#resources h3{
  
}

#resources .resourceLink{
  display: block;
  text-decoration: none;
}

#resources .resource{
  text-align: center;
  margin: 60px 20px;
  -webkit-box-shadow: 0px 0px 20px 5px rgba(102,102,102,0.15);
-moz-box-shadow: 0px 0px 20px 5px rgba(102,102,102,0.15);
box-shadow: 0px 0px 20px 5px rgba(102,102,102,0.15);
  margin-top: 20px;
}

#resources .resourceCollection{
  margin:0 15px;
}

#resources .resource .card{
  min-height: 170px;
  height: 100%;
  position: relative;
  cursor: pointer;

  background-color: #F2F2F2;

  -webkit-transition: background-size 200ms linear;
  -moz-transition: background-size 200 linear;
  -o-transition: background-size 200 linear;
  -ms-transition: background-size 200ms linear;
  transition: background-size 200ms linear;
}

#resources .goBackCard{
  background: url(/static/bg-collection.png) scroll repeat-y center 10px;
  -webkit-animation: backgroundScroll 20s linear infinite;
  animation: backgroundScroll 20s linear infinite;  
}

@-webkit-keyframes backgroundScroll {
  from {background-position: center 0;}  
  to {background-position: center -300px;}  
}

@keyframes backgroundScroll {
  from {background-position: center 0;}  
  to {background-position: center -300px;}  
}

#resources .resourceCollection .card{

  background: 
    /* grey gradient */ 
    linear-gradient(
      rgba(51, 51, 51, 0.5), 
      rgba(51, 51, 51, 0.5)
    ) scroll no-repeat center center;
}

#resources .resourceCollection .races{
  background: /* grey gradient */ 
    linear-gradient(
      rgba(51, 51, 51, 0.5), 
      rgba(51, 51, 51, 0.5)
    ),
    url(/static/bg-races.jpg) scroll no-repeat center center;
}

#lower-body.races{
  background: 
    linear-gradient(
      rgba(0, 0, 0, 0.75), 
      rgba(0, 0, 0, 0.75)
    ),
    url(/static/bg-races.jpg) scroll no-repeat center center;
}

#resources .resourceCollection .parkrun{
 background: 
    /* grey gradient */ 
    linear-gradient(
      rgba(51, 51, 51, 0.5), 
      rgba(51, 51, 51, 0.5)
    ),
    /* bottom, image */ 
    url(/static/bg-parkrun.jpg) scroll no-repeat center center;
}

#lower-body.parkrun{
  background: 
    linear-gradient(
      rgba(0, 0, 0, 0.75), 
      rgba(0, 0, 0, 0.75)
    ),
    url(/static/bg-parkrun.jpg) scroll no-repeat center center;
}

#resources .resourceCollection .apps{
 background: 
    /* grey gradient */ 
    linear-gradient(
      rgba(51, 51, 51, 0.5), 
      rgba(51, 51, 51, 0.5)
    ),
    /* bottom, image */ 
    url(/static/bg-apps.jpg) scroll no-repeat center center;
}

#lower-body.apps{
  background: 
    linear-gradient(
      rgba(0, 0, 0, 0.75), 
      rgba(0, 0, 0, 0.75)
    ),
    url(/static/bg-apps.jpg) scroll no-repeat center center;
}

#resources .resourceCollection .gettingstarted{
 background: 
    /* grey gradient */ 
    linear-gradient(
      rgba(51, 51, 51, 0.5), 
      rgba(51, 51, 51, 0.5)
    ),
    /* bottom, image */ 
    url(/static/bg-gettingstarted.jpg) scroll no-repeat center center;
}

#lower-body.gettingstarted{
  background: 
    linear-gradient(
      rgba(0, 0, 0, 0.75), 
      rgba(0, 0, 0, 0.75)
    ),
    url(/static/bg-gettingstarted.jpg) scroll no-repeat center center;
}

#resources .resourceCollection .injuries{
 background: 
    /* grey gradient */ 
    linear-gradient(
      rgba(51, 51, 51, 0.5), 
      rgba(51, 51, 51, 0.5)
    ),
    /* bottom, image */ 
    url(/static/bg-injuries.jpg) scroll no-repeat center center;
}

#lower-body.injuries{
  background: 
    linear-gradient(
      rgba(0, 0, 0, 0.75), 
      rgba(0, 0, 0, 0.75)
    ),
    url(/static/bg-injuries.jpg) scroll no-repeat center center;
}

#resources .resourceCollection .websites{
 background: 
    /* grey gradient */ 
    linear-gradient(
      rgba(51, 51, 51, 0.5), 
      rgba(51, 51, 51, 0.5)
    ),
    /* bottom, image */ 
    url(/static/bg-websites.jpg) scroll no-repeat center center;
}

#lower-body.websites{
  background: 
    linear-gradient(
      rgba(0, 0, 0, 0.75), 
      rgba(0, 0, 0, 0.75)
    ),
    url(/static/bg-websites.jpg) scroll no-repeat center center;
}

#resources .resourceCollection .nutrition{
 background: 
    /* grey gradient */ 
    linear-gradient(
      rgba(51, 51, 51, 0.5), 
      rgba(51, 51, 51, 0.5)
    ),
    /* bottom, image */ 
    url(/static/bg-nutrition.jpg) scroll no-repeat center center;
}

#lower-body.nutrition{
  background: 
    linear-gradient(
      rgba(0, 0, 0, 0.75), 
      rgba(0, 0, 0, 0.75)
    ),
    url(/static/bg-nutrition.jpg) scroll no-repeat center center;
}

#resources .resourceCollection .accessories{
 background: 
    /* grey gradient */ 
    linear-gradient(
      rgba(51, 51, 51, 0.5), 
      rgba(51, 51, 51, 0.5)
    ),
    /* bottom, image */ 
    url(/static/bg-accessories.jpg) scroll no-repeat center center;
}

#lower-body.accessories{
  background: 
    linear-gradient(
      rgba(0, 0, 0, 0.75), 
      rgba(0, 0, 0, 0.75)
    ),
    url(/static/bg-accessories.jpg) scroll no-repeat center center;
}

#resources .resourceCollection .clothing{
 background: 
    /* grey gradient */ 
    linear-gradient(
      rgba(51, 51, 51, 0.5), 
      rgba(51, 51, 51, 0.5)
    ),
    /* bottom, image */ 
    url(/static/bg-clothing.jpg) scroll no-repeat center center;
}

#lower-body.clothing{
  background: 
    linear-gradient(
      rgba(0, 0, 0, 0.75), 
      rgba(0, 0, 0, 0.75)
    ),
    url(/static/bg-clothing.jpg) scroll no-repeat center center;
}

#resources .resource:hover .card{
  background-color: #FFF;
}

#resources .resourceCollection .card{
  /* Must be defined after custom cards CSS */
  background-size: 100%;
}

#resources .resourceCollection:hover .card{
  background-size: 110%;
}

#resources .resourceCollection:hover span{
  color: #FFF;
  text-shadow: 0px 0px 5px #FFF;
}

/* Tile shadow @hover */
#resources .resource:hover{
  -webkit-box-shadow: 0px 0px 20px 5px rgba(160, 125, 80, 0.5);
-moz-box-shadow: 0px 0px 20px 5px rgba(160, 125, 80, 0.5);
box-shadow: 0px 0px 20px 5px rgba(160, 125, 80, 0.5);
}


  #resources .resource h1{
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    padding-top:60px;
    font-size: 28px;
    color:#333;
    font-weight: 200;
  }

  #resources h2{
  margin: 0 21px;
  font-size: 20px;
  color: #888;
  line-height: 40px;
  padding-top: 50px;
  font-weight: 200;
  }

  #resources .resourceCollection h1{
    color:#FFF;
    padding-top:50px;
  }

  .resource p{
    color:#666;
    font-weight: 100;
    margin: 16px 20px;
    line-height: 25px;
  }

  .resourceCollection p{
    color: #eee;
    font-size: 19px;
    text-shadow: 0px 0px 2px #666;
  }

  .resourceCollection span{
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 100px;
    font-weight: 100;
    opacity: 0.3;
    color: #FFF;
    text-shadow: 0px 0px 5px #333;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  .resource .resourceLogo{
    position: absolute;
    top: -35px;
    width: 80px;
    height: 80px;
    left: calc(50% - 40px);
    border-radius: 40px;
    border: 2px solid #e1e1e1;
    background-color: #FFF;
    -webkit-box-shadow: -2px 2px 20px 5px rgba(140,140,140,.2);
    -moz-box-shadow: -2px 2px 20px 5px rgba(140,140,140,.2);
    box-shadow: -2px 2px 20px 5px rgba(140,140,140,.2);
  }

#resources .button{
  text-align: center;
  height: 50px;
  font-size: 18px;
  line-height: 50px;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  background-color: #FFF;
}

#resources .resource:hover .button{
  background-color: #77b165;
  color: #FFF;
  font-weight: 100;
}

#resources .resourceCollection .button{
  font-weight: 100;
}

#resources .total{
  text-align: center;
  display: block;
  height: 50px;
  line-height: 50px;
  color: #666;
  margin-bottom: 30px;
}

</style>



// WEBPACK FOOTER //
// Resources.vue?17a7532b